import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";

import "./Wishlist.css";

const Wishlist = () => {
  const { wishlistItems = [], removeFromWishlist } = useWishlist();

  const { addToCart } = useCart();

  const safeWishlistItems = Array.isArray(wishlistItems) ? wishlistItems : [];

  const handleAddToCart = (product) => {
    addToCart(product);
    alert(`${product.name} added to cart`);
  };

  if (safeWishlistItems.length === 0) {
    return (
      <main className="wishlist-page">
        <section className="wishlist-header">
          <p>STAR GOLD</p>
          <h1>My Wishlist</h1>
        </section>

        <section className="wishlist-empty">
          <div className="wishlist-empty-icon">♡</div>

          <h2>Your wishlist is empty</h2>

          <p>
            Save your favourite jewellery here and come back to them anytime.
          </p>

          <Link to="/collections" className="wishlist-shop-button">
            Explore Collections
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="wishlist-page">
      <section className="wishlist-header">
        <p>STAR GOLD</p>

        <h1>My Wishlist</h1>

        <span>
          {safeWishlistItems.length}{" "}
          {safeWishlistItems.length === 1 ? "item" : "items"}
        </span>
      </section>

      <section className="wishlist-products">
        <div className="wishlist-grid">
          {safeWishlistItems.map((product) => {
            const hasSalePrice =
              product.salePrice !== null &&
              product.salePrice !== undefined &&
              Number(product.salePrice) < Number(product.price);

            return (
              <article className="wishlist-card" key={product.id}>
                <div className="wishlist-image-wrapper">
                  <Link to={`/product/${product.id}`}>
                    <img src={product.imageUrl} alt={product.name} />
                  </Link>

                  <button
                    type="button"
                    className="wishlist-remove"
                    onClick={() => removeFromWishlist(product.id)}
                    aria-label="Remove from wishlist"
                  >
                    ♥
                  </button>
                </div>

                <div className="wishlist-card-info">
                  <p>{product.category}</p>

                  <h3>
                    <Link to={`/product/${product.id}`}>{product.name}</Link>
                  </h3>

                  <div className="wishlist-price">
                    {hasSalePrice ? (
                      <>
                        <span className="wishlist-original-price">
                          ₹{product.price}
                        </span>

                        <span className="wishlist-sale-price">
                          ₹{product.salePrice}
                        </span>
                      </>
                    ) : (
                      <span>₹{product.price}</span>
                    )}
                  </div>

                  <button
                    type="button"
                    className="wishlist-cart-button"
                    onClick={() => handleAddToCart(product)}
                    disabled={Number(product.stock) <= 0}
                  >
                    {Number(product.stock) > 0 ? "Add to Cart" : "Out of Stock"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Wishlist;
